<template>
    <div>
        <slot />
    </div>
</template>

<script>
import 'flickity/dist/flickity.min.css';

let Flickity;
if (process.browser) {
    Flickity = require('flickity');
}

export default {
    props: {
        options: {
            type: Object,
            default: () => {}
        },
        activeSlideProp: {
            type: Number,
            default: null
        },
        cellsFullHeight: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        carousel: null,
        cellCount: 0,
        activeSlideLocal: 0
    }),

    computed: {
        activeSlide() {
            return this.activeSlideProp || this.activeSlideLocal;
        }
    },

    watch: {
        activeSlide() {
            this.carousel.select(this.activeSlide);
        },
        activeSlideProp() {
            this.carousel.select(this.activeSlideProp);
        }
    },

    mounted() {
        this.init();
    },

    beforeDestroy() {
        // Wait for transitions

        window.setTimeout(() => {
            this.carousel.destroy();
            this.carousel = null;
        }, 1500);
    },

    methods: {
        init() {
            this.carousel = new Flickity(this.$el, this.options);
            this.carousel.on('change', (index) => this.$emit('change', index));
            this.carousel.select(this.activeSlide);
            this.carousel.on('settle', () => {
                this.resize();
                this.$el.classList.add('carousel-initialised');
            });
            this.cellCount = this.$slots && this.$slots.default.length;

            if (this.cellsFullHeight) {
                this.stretchCells();
            } else {
                const interval = setInterval(this.resize, 200);
                setTimeout(() => clearInterval(interval), 2000);
            }
        },

        resize() {
            if (this.carousel) {
                this.carousel.resize();
            }
        },

        stretchCells() {
            const cards = Array.from(this.$el.querySelectorAll('.flickity-slider > div'));
            cards.forEach((card) => {
                card.classList.remove('min-h-full');
                card.classList.add('min-h-full');
            });
            const interval = setInterval(this.carousel.resize, 200);
            setTimeout(() => clearInterval(interval), 2000);
        }
    }
};
</script>
<style>
.flickity-page-dots {
    @apply left-0 block pt-10 static;
}

.flickity-page-dots .dot {
    @apply w-6 h-1 bg-blue-500 rounded-none mx-1 !important;
}

.flickity-viewport {
    @apply overflow-visible !important;
}
</style>
